module.exports = {

  api: {
    API_URL: "http://14.141.71.10:9494/bigulpay",
  },
};
